import React from 'react'
import Modal from '../Modal'

const DeleteConfirmationModal = ({
    open,
    onClose,
    onConfirm,
    title = 'Confirm Delete',
    message = 'Are you sure you want to delete this item?'
}) => {
    if (!open) return null

    return (
        <Modal onClose={onClose}>
            <div className="space-y-4">
                <h2 className="text-lg font-semibold text-gray-800">
                    {title}
                </h2>

                <p className="text-sm text-gray-600">
                    {message}
                </p>

                <div className="flex justify-end gap-3 mt-4">
                    <button
                        onClick={onClose}
                        className="button login-button !w-fit !bg-gray-500 !text-white  "
                    >
                        Cancel
                    </button>

                    <button
                        onClick={onConfirm}
                        className="button login-button !w-fit !text-white"
                    >
                        Delete
                    </button>
                </div>
            </div>
        </Modal>
    )
}

export default DeleteConfirmationModal
